import * as React from 'react';

import {LoadingIcon, RepeatIcon} from 'shells/icon';

import {ButtonGroup} from '../button-group/button-group';
import {Button} from '../button/button';
import {colors} from '../colors/colors';

import styles from './mfa-recovery-codes.module.css';

type Props = {
    codes: string[];
    usedCodes?: string[];
    isLoading: boolean;
    showRegenerateButton?: boolean;
    onCodesSaved?: () => void;
    generateNewCodes?: () => void;
    getRegenerateButtonRef?: any;
};

export function MfaRecoveryCodes(props: Props) {
    const [didCopyCodes, setDidCopyCodes] = React.useState<boolean>(false);
    const {codes} = props;

    const getCodesAsList = () => {
        let codesList = '';
        for (let i = 0; i < codes.length; i++) {
            // @ts-expect-error
            codesList = codesList.concat(codes[i], i >= codes.length - 1 ? '' : ', ');
        }

        return codesList;
    };

    const codesHaveBeenSaved = () => {
        if (props.onCodesSaved) {
            props.onCodesSaved();
        }
    };

    const copyCodes = () => {
        navigator.clipboard.writeText(getCodesAsList());
        setDidCopyCodes(true);

        setTimeout(() => {
            setDidCopyCodes(false);
        }, 3000);

        codesHaveBeenSaved();
    };

    const printCodes = () => {
        const recoveryCodePrint = window.open();
        // @ts-expect-error
        recoveryCodePrint.document.title = 'Nutshell Recovery Codes';
        // @ts-expect-error
        recoveryCodePrint.document.body.innerHTML = `Nutshell Recovery Codes: ${getCodesAsList()}`;
        // @ts-expect-error
        recoveryCodePrint.print();

        codesHaveBeenSaved();
    };

    const downloadCodes = () => {
        const text = getCodesAsList();

        const element = document.createElement('a');
        element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`);
        element.setAttribute('download', 'nutshell-recovery-codes.txt');

        element.style.display = 'none';
        if (document.body) {
            document.body.appendChild(element);
        }

        element.click();

        if (document.body) {
            document.body.removeChild(element);
        }

        codesHaveBeenSaved();
    };

    const {getRegenerateButtonRef} = props;

    return (
        <>
            {props.isLoading ? (
                <div className={styles['loading-container']}>
                    <LoadingIcon fill={colors.greyLt} />
                </div>
            ) : (
                <div onCopy={codesHaveBeenSaved} className={styles['recovery-codes-container']}>
                    <div className={styles['recovery-codes-inner-container']}>
                        {props.codes.map((code) => {
                            return (
                                <div key={code} className={styles['code']}>
                                    {code}
                                </div>
                            );
                        })}

                        {props.usedCodes
                            ? props.usedCodes.map((code) => {
                                  return (
                                      <div key={code} className={styles['usedCode']}>
                                          {code}
                                      </div>
                                  );
                              })
                            : undefined}
                    </div>
                </div>
            )}
            <div className={styles['buttons-container']}>
                {props.showRegenerateButton ? (
                    <Button
                        // @ts-expect-error
                        disabled={props.isLoading}
                        size='big'
                        variant='primary'
                        onClick={props.generateNewCodes}
                        icon={RepeatIcon}
                        getButtonRef={getRegenerateButtonRef}
                        className={styles['generate-button']}
                    >
                        Generate new codes
                    </Button>
                ) : null}

                <div className={styles['recovery-button-group']}>
                    <ButtonGroup>
                        <Button
                            // @ts-expect-error
                            disabled={didCopyCodes || props.isLoading}
                            size='big'
                            onClick={copyCodes}
                            className={styles['button']}
                        >
                            {didCopyCodes ? 'Copied!' : 'Copy'}
                        </Button>
                        <Button
                            // @ts-expect-error
                            disabled={props.isLoading}
                            size='big'
                            variant='primary'
                            onClick={downloadCodes}
                            className={styles['button']}
                        >
                            Download
                        </Button>
                        <Button
                            // @ts-expect-error
                            disabled={props.isLoading}
                            size='big'
                            variant='primary'
                            onClick={printCodes}
                            className={styles['button']}
                        >
                            Print
                        </Button>
                    </ButtonGroup>
                </div>
            </div>
        </>
    );
}
